

































































































































































































































































































































































import Vue from "vue";
import store, {
  GeneralIngoingInvoiceEditModelStore,
} from "../generalIngoingInvoiceEditModel/services/GeneralIngoingInvoiceEditModelStore";
import store2, { GeneralIngoingInvoiceStore } from "../generalIngoingInvoice/services/GeneralIngoingInvoiceStore";
import { CompositeFilterDescriptor, filterBy, orderBy, SortDescriptor } from "@progress/kendo-data-query";
import flowStore, { InvoiceFlowStore } from "../invoiceFlow/services/InvoiceFlowStore";
import FlowPaymentInfoView from "../invoiceFlow/views/FlowPaymentInfoView.vue";
import configuration, { AppConfiguration } from "@/models/Configuration";
import MoneyDisplay from "../../components/MoneyDisplay.vue";
import Tooltip from "@/components/Tooltip.vue";
import InvoiceStockModfierGenisView from "@/modules/incomingInvoice/invoiceStockModification/views/InvoiceStockModfierGenisView.vue";
import ApiSearchPage from "@/components/apiSearch/components/ApiSearchPage.vue";
import InvoiceBrowserExtraFilter from "@/modules/invoiceBrowser/InvoiceBrowserExtraFilter.vue";
import ApiSearch, { ApiSearchColumn, ColumnType } from "@/components/apiSearch/models/ApiSearch";
import dayjs from "dayjs";
import eventBus from "@/services/eventBus";
import DateInput from "@/components/DateInput.vue";
import CheckBox from "@/components/CheckBox.vue";
import GenoEInvoiceDocuments from "@/modules/kanri/components/GenoEInvoiceDocuments.vue";
import EmailPicker from "@/modules/bankStatement/views/EmailPicker.vue";
import http, { checkResponse } from "@/services/http";
import ApiResponse from "@/models/ApiResponse";
import pStore, {
  PaymentModeStore,
} from "@/modules/paymentMode/services/PaymentModeStore";

interface Data {
  configuration: AppConfiguration;
  store: GeneralIngoingInvoiceEditModelStore;
  store2: GeneralIngoingInvoiceStore; // miert kellett 2 store?
  flowStore: InvoiceFlowStore;
  filter: CompositeFilterDescriptor;
  extraFilter: CompositeFilterDescriptor;
  sort: SortDescriptor[];
  loading: boolean;
  pStore: PaymentModeStore;
}

interface Methods {
  // TODO InvoiceBrowserModel -t fel kéne venni az any-k helyett
  showDetails(item: any): void;
  editInvoice(item: any): void;
  editDpaymInvoice(item: number, partner: number): void;
  editPreDpaymInvoice(item: number): void;
  convertToDate(dateString: string): string;
  handleExtraFilterToggle(isVisible: boolean): void;
  handleResetFiltering(): void;
  syncInvoiceFilter(): void;
  refreshApiSearch(): void;
  showInvImage(item: any): void;
  showResendEInvoice(item: any): void;
  cancelResendEInvoice(item: any): void;
  sendResendEInvoice(item: any): Promise<void>;
  hasSourceNoto(item: any): boolean;
  resendDocId(item: any): number;
  resendDocTable(item: any): string;
  viewButtonClick(): void;
}

interface Computed {
  columns: ApiSearchColumn[];
  viewButtonText: string | null;
  typeLabel: string;
}

export default Vue.extend<Data, Methods, Computed, {}>({
  components: {
    FlowPaymentInfoView,
    MoneyDisplay,
    InvoiceStockModfierGenisView,
    Tooltip,
    ApiSearchPage,
    InvoiceBrowserExtraFilter,
    CheckBox,
    DateInput,
    EmailPicker,
    GenoEInvoiceDocuments,
  },

  data: () => ({
    configuration,
    store,
    store2,
    flowStore,
    filter: {
      logic: "and",
      filters: [],
    },
    extraFilter: {
      logic: "and",
      filters: [],
    },
    sort: [],
    loading: false,
    pStore
  }),

  async beforeMount() {
    // be kell várni az értékkészleteket a státusz szűrésnél
    this.loading = true;

    try {
      if (!this.configuration.operel) {
        await Promise.all([
          this.store.loadAccountStatuses(),
          this.store.loadStatusNames(),
          this.store2.loadTypes(),
          /*a flowstatus-t manualisan beallitjuk a store-ban */
        ]);
      } else {
        await Promise.all([this.store.loadAccountStatuses(), this.store.loadStatusNames()]);
      }

      if (this.pStore.paymentModesForFilter.length < 2) {
        await this.pStore.loadPaymentModesForFilter();
      }

    } catch (error) {
      console.error(error);
      eventBus.$emit("error", "Hiba történt az adatok lekérdezésekor!");
    } finally {
      this.loading = false;
    }
  },

  mounted(){
    const oneYearAgo = new Date();
    // oneYearAgo.setFullYear(new Date().getFullYear() - 1);
    oneYearAgo.setFullYear(new Date().getFullYear() - (configuration.sysParams.invBrowserDefFromYearFilter || 1));

    (this.store2.eFilters.filters.invDateFrom as any).value = oneYearAgo.toISOString().split('T')[0].replaceAll('-', '.'); // ennél a dátumnál frissebb számlákat kérünk le a backendről
  },

  beforeDestroy() {
    this.store.clearStatuses();
    this.handleResetFiltering();
  },

  computed: {
    columns(){
      return this.$route.params.typeFilter == 'all' ? [
      {
        cell: "invoiceDetailsTemplate",
        filterable: false,
      },
      {
        cell: "invoiceInvImageCommandTemplate",
        filterable: false,
      },
      {
        cell: "resendEInvoiceCommandTemplate",
        filterable: false,
      },
      {
        field: "id",
        title: "Azonosító",
        cell: "IDTemplate",
        fieldClass: "align__field__center",
        headerClass: "align__center",
      },
      { field: "prefix", title: "Prefix", cell: "prefixTemplate" },
      {
        field: "invoiceNo",
        title: "Bizonylat szám",
        cell: "invoiceNoTemplate",
      },
      {
        field: "partner",
        title: "Partner ID",
        fieldClass: "align__field__center",
        headerClass: "align__center",
      },
      {
        field: "partnerName",
        title: "Partner",
        headerClass: "geniLabel",
      },
      {
        field: "invoiceTypeName",
        title: "Számla típusa",
      },
      {
        field: "paymentModeName",
        title: "Fizetési mód",
        multiselect: true,
        multiselectField: "pmodes",
        multiselectOptions: this.pStore.paymentModesForFilter.map((x) => ({
          text: x.name,
          value: x.id,
        })),
        multiselectSelect: this.pStore.paymentModesForFilter.map((x) => x.id),
      },
      {
        field: "dpaymInv",
        title: "Előleg számla",
        cell: "dpaymTemplate",
        sortable: false,
      },
      {
        field: "preDpaymInv",
        title: "Előlegbekérő",
        cell: "preDpaymTemplate",
        sortable: false,
      },
      {
        field: "invoiceDate",
        title: "Számla dátuma",
        cell: "invoiceDateTemplate",
        filterable: false,
      },
      {
        field: "payTerm",
        title: "Fizetési határidő",
        cell: "payTermTemplate",
        filterable: false,
      },
      {
        field: "crediting",
        title: "Jóváíró/Jóváírt",
        fieldClass: "align__field__center",
        multiselect: true,
        multiselectField: "selectedCrediting",
        multiselectOptions: [{text: '-', value: '-'}, {text: 'Jóváíró', value: 'Jóváíró'}, { text: 'Jóváírt', value: 'Jóváírt'}],
      },
      {
        field: "statusName",
        title: "Státusz",
      },
      {
        field: "navStatusName",
        title: "NAV státusz",
      },
      {
        field: "divItem",
        title: "Üzletág",
      },
      {
        field: "currTotal",
        cell: "bruttoTemplate",
        title: "Bruttó",
        fieldClass: "align__right",
        headerClass: "align__right",
      },
      {
        field: "currPaymSum",
        cell: "sumpayTemplate",
        title: "Eddig fizetett",
      },
      {
        field: "invCurrency",
        title: "Pénznem",
        cell: "currencyTemplate",
      },
      {
        field: "shipDate",
        title: "Teljesítés dátuma",
        cell: "shipDateTemplate",
        filterable: false,
      },
      {
        field: "regDate",
        title: "Iktatás dátuma",
        cell: "regDateTemplate",
        filterable: false,
      },
      {
        field: "flowModDate",
        title: "Módosítás dátuma",
        cell: "flowModDateTemplate",
        filterable: false,
      },
      {
        field: "flowUserName",
        title: "Módosító",
      },
      {
        title: "Könyvelési státusz",
        field: "accStatusName",
        cell: "accStatusTemplate",
        fieldClass: "align__field__center",
        multiselect: true,
        multiselectField: "selectedAccStatuses",
        multiselectOptions: store.accountStatuses.map((x) => ({ text: x.name, value: x.id })),
      },
      {
        field: "bodyNo",
        title: "Alvázszám",
        sortable: false,
      },
      {
        title: "Számla jóváhagyási státusz",
        field: "preStatusName",
        cell: "preStatusNameTemplate",
        fieldClass: "align__field__center",
        multiselect: true,
        multiselectField: "selectedPreStatuses",
        multiselectOptions: store.statusNames.map((x) => ({ text: x.name, value: x.id })),
      },
      {
        field: "flowStatusName",
        title: "Workflow státusz",
        cell: "flowStatusTemplate",
        fieldClass: "align__field__center",
        multiselect: true,
        multiselectField: "selectedFlowStatuses",
        multiselectOptions: store.flowStatuses.map((x) => ({ text: x.name, value: x.id })),
      },
      {
        field: "daysSpentInStatus",
        title: "Státuszban eltöltött idő",
        cell: "daysSpentTemplate",
      },
      {
        field: "isIntrastat",
        title: "Lehetséges intrastat",
        cell: "isIntrastat",
        type: ColumnType.Center,
        multiselect: true,
        multiselectField: "selectedIsIntrastat",
        multiselectOptions: [
          { text: "Nem", value: 0 },
          { text: "Igen", value: 1 },
        ],
      },
      {
        field: "isIndirectNoserv",
        title: "Nem készletes intrastatos",
        cell: "isIndirectNoserv",
        type: ColumnType.Center,
        multiselect: true,
        multiselectField: "selectedIsIndirectNoserv",
        multiselectOptions: [
          { text: "Nem", value: 0 },
          { text: "Igen", value: 1 },
        ],
      },
      {
        field: "intrastatIds",
        title: "Intrastat azonosítók",
        cell: "intrastatIds",
      },
      {
        field: "remark1",
        title: "Megjegyzés",
        fieldClass: "remark",
      },
    ] : [
      {
        cell: "invoiceDetailsTemplate",
        filterable: false,
      },
      {
        cell: "invoiceInvImageCommandTemplate",
        filterable: false,
      },
      {
        cell: "resendEInvoiceCommandTemplate",
        filterable: false,
      },
      {
        field: "id",
        title: "Azonosító",
        cell: "IDTemplate",
        fieldClass: "align__field__center",
        headerClass: "align__center",
      },
      { field: "prefix", title: "Prefix", cell: "prefixTemplate" },
      {
        field: "invoiceNo",
        title: "Bizonylat szám",
        cell: "invoiceNoTemplate",
      },
      {
        field: "partner",
        title: "Partner ID",
        fieldClass: "align__field__center",
        headerClass: "align__center",
      },
      {
        field: "partnerName",
        title: "Partner",
        headerClass: "geniLabel",
      },
      {
        field: "invoiceTypeName",
        title: "Számla típusa",
      },
      {
        field: "paymentModeName",
        title: "Fizetési mód",
        multiselect: true,
        multiselectField: "pmodes",
        multiselectOptions: this.pStore.paymentModesForFilter.map((x) => ({
          text: x.name,
          value: x.id,
        })),
        multiselectSelect: this.pStore.paymentModesForFilter.map((x) => x.id),
      },
      {
        field: "dpaymInv",
        title: "Előleg számla",
        cell: "dpaymTemplate",
        sortable: false,
      },
      {
        field: "preDpaymInv",
        title: "Előlegbekérő",
        cell: "preDpaymTemplate",
        sortable: false,
      },
      {
        field: "invoiceDate",
        title: "Számla dátuma",
        cell: "invoiceDateTemplate",
        filterable: false,
      },
      {
        field: "payTerm",
        title: "Fizetési határidő",
        cell: "payTermTemplate",
        filterable: false,
      },
      {
        field: "crediting",
        title: "Jóváíró/Jóváírt",
        fieldClass: "align__field__center",
        multiselect: true,
        multiselectField: "selectedCrediting",
        multiselectOptions: [{text: '-', value: '-'}, {text: 'Jóváíró', value: 'Jóváíró'}, { text: 'Jóváírt', value: 'Jóváírt'}],
      },
      {
        field: "statusName",
        title: "Státusz",
      },
      {
        field: "navStatusName",
        title: "NAV státusz",
      },
      {
        field: "currTotal",
        cell: "bruttoTemplate",
        title: "Bruttó",
        fieldClass: "align__right",
        headerClass: "align__right",
      },
      {
        field: "currPaymSum",
        cell: "sumpayTemplate",
        title: "Eddig fizetett",
      },
      {
        field: "invCurrency",
        title: "Pénznem",
        cell: "currencyTemplate",
      },
      {
        field: "shipDate",
        title: "Teljesítés dátuma",
        cell: "shipDateTemplate",
        filterable: false,
      },
      {
        field: "regDate",
        title: "Iktatás dátuma",
        cell: "regDateTemplate",
        filterable: false,
      },
      {
        field: "flowModDate",
        title: "Módosítás dátuma",
        cell: "flowModDateTemplate",
        filterable: false,
      },
      {
        field: "flowUserName",
        title: "Módosító",
      },
      {
        title: "Könyvelési státusz",
        field: "accStatusName",
        cell: "accStatusTemplate",
        fieldClass: "align__field__center",
        multiselect: true,
        multiselectField: "selectedAccStatuses",
        multiselectOptions: store.accountStatuses.map((x) => ({ text: x.name, value: x.id })),
      },
      {
        field: "bodyNo",
        title: "Alvázszám",
        sortable: false,
      },
      ...(this.$route.params.typeFilter === "outgoing"
        ? [
            {
              field: "regNum",
              title: "Rendszám",
              sortable: false,
            },
          ]
        : []),
      // a Kanri munkalapszám Kanri-működésű rendszerben, GENO számlákra értelmezett
      ...(this.$route.params.typeFilter === "outgoing" && this.configuration.sysParams.isKanriEnabled
        ? [
            {
              field: "worksheetNo",
              title: "Kanri munkalapszám",
              sortable: false,
            },
          ]
        : []),
      {
        title: "Számla jóváhagyási státusz",
        field: "preStatusName",
        cell: "preStatusNameTemplate",
        fieldClass: "align__field__center",
        multiselect: true,
        multiselectField: "selectedPreStatuses",
        multiselectOptions: store.statusNames.map((x) => ({ text: x.name, value: x.id })),
      },
      {
        field: "flowStatusName",
        title: "Workflow státusz",
        cell: "flowStatusTemplate",
        fieldClass: "align__field__center",
        multiselect: true,
        multiselectField: "selectedFlowStatuses",
        multiselectOptions: store.flowStatuses.map((x) => ({ text: x.name, value: x.id })),
      },
      {
        field: "daysSpentInStatus",
        title: "Státuszban eltöltött idő",
        cell: "daysSpentTemplate",
      },
      {
        field: "isIntrastat",
        title: "Lehetséges intrastat",
        cell: "isIntrastat",
        type: ColumnType.Center,
        multiselect: true,
        multiselectField: "selectedIsIntrastat",
        multiselectOptions: [
          { text: "Nem", value: 0 },
          { text: "Igen", value: 1 },
        ],
      },
      {
        field: "isIndirectNoserv",
        title: "Nem készletes intrastatos",
        cell: "isIndirectNoserv",
        type: ColumnType.Center,
        multiselect: true,
        multiselectField: "selectedIsIndirectNoserv",
        multiselectOptions: [
          { text: "Nem", value: 0 },
          { text: "Igen", value: 1 },
        ],
      },
      {
        field: "intrastatIds",
        title: "Intrastat azonosítók",
        cell: "intrastatIds",
      },
      {
        field: "remark1",
        title: "Megjegyzés",
        fieldClass: "remark"
      },
    ];
    },

    viewButtonText() {
      if (this.$route.params.typeFilter === "incoming") return `Váltás a "Minden számla" nézetre`;
      if (this.$route.params.typeFilter === "outgoing") return `Váltás a "Minden számla" nézetre`;
      if (this.$route.params.typeFilter === "all") return null;
      return null;
    },

    typeLabel() {
      if (this.$route.params.typeFilter === "incoming") return "(Bejövő számlák)";
      if (this.$route.params.typeFilter === "outgoing") return "(Kimenő számlák)";
      if (this.$route.params.typeFilter === "all") return "(Minden számla)";
      return "";
    },
  },

  methods: {
    editInvoice(item) {
      if (item.prefix === "GENI") {
        if (item.preDownPayment){
          this.$router.push(`/down-payment/edit/${item.id}`);
        } else {
          const path = configuration.invoiceFlow.enabled
          ? item.isStockCorrection
            ? `/uninvoiced-stock-correction/edit/${item.id}`
            : `/general-incoming-invoice/flow/edit/${item.id}/${item.flowStatus}`
          : `/general-incoming-invoice/edit/${item.partner}/${item.id}`;

        this.$router.push(path);
        }
      }

      if (item.prefix === "NOTO") {
        this.$router.push(`/noto/${item.id}`);
      }
    },
    editDpaymInvoice(item, partner) {
      const path = configuration.invoiceFlow.enabled
        ? `/general-incoming-invoice/flow/edit/${item}/4`
        : `/general-incoming-invoice/edit/${partner}/${item}`;

      this.$router.push(path);
    },

    editPreDpaymInvoice(item) {
      const path = `/down-payment/edit/${item}`;

      this.$router.push(path);
    },

    showDetails(item: any) {
      item.expanded = !item.expanded;
    },

    convertToDate(dateString) {
      if (dayjs(dateString).isValid()) {
        return dayjs(dateString).format("YYYY-MM-DD");
      }
      return "-";
    },

    //szűrő gombnyomás
    handleExtraFilterToggle(isVisible: boolean) {
      if (!isVisible) {
        this.handleResetFiltering();
        this.refreshApiSearch();
      }
    },

    // szűrők törlése gombnyomás
    handleResetFiltering() {
      this.store2.resetExtraFilter();
    },

    syncInvoiceFilter() {
      (this.store2.eFilters.filters.invoiceFilter as any).value =
        this.$route.params.filtered === "filtered" && this.store2.invoiceFilter.length > 0
          ? this.store2.invoiceFilter
          : null;
    },

    refreshApiSearch() {
      const childComponentInstance = this.$refs.asref;
      if (childComponentInstance) {
        (this.$refs.asref as any).refreshClick();
      }
    },

    async showInvImage(item) {
      await this.store.openInvoiceImage(item.id, item.prefix);
    },

    showResendEInvoice(item: any) {
      if (item.resendMode) {
        this.cancelResendEInvoice(item);
        return;
      }
      this.$set(item, "resendMode", true);
      this.$set(item, "resendEmails", []);
      this.$set(item, "expanded", true);
    },

    cancelResendEInvoice(item: any) {
      this.$set(item, "resendMode", false);
      this.$set(item, "resendEmails", []);
      this.$set(item, "expanded", false);
    },

    // Ha van forrás NOTO (rmaccnoto_dpaym alapján), ahhoz csatolunk; egyébként magához a számlához.
    hasSourceNoto(item: any): boolean {
      return (item.sourceNoto ?? 0) >= 2;
    },

    resendDocId(item: any): number {
      return this.hasSourceNoto(item) ? item.sourceNoto : item.id;
    },

    resendDocTable(item: any): string {
      return this.hasSourceNoto(item) ? "hmouinotinvoice" : (item.documentTable || "hmouigeninvoice");
    },

    async sendResendEInvoice(item: any) {
      try {
        const emails: string[] = (item.resendEmails || []).map((e: any) => e.email);
        if (emails.length === 0) {
          eventBus.$emit("error", "Nincs kiválasztott email cím!");
          return;
        }
        await http
          .put<ApiResponse<{}>>(`invoice-browser/resend-einvoice/${item.prefix}/${item.id}`, { emails: emails })
          .then(checkResponse);
        eventBus.$emit("success", "E-számla sikeresen újraküldve!");
      } catch (ex) {
        console.log(ex);
        eventBus.$emit("error", "Nem sikerült az e-számla újraküldése!");
      } finally {
        this.cancelResendEInvoice(item);
      }
    },

    viewButtonClick() {
      this.$router.push(`/invoice-browser/all`);
    },
  },
});
